import { render } from "./CauseMultiples.vue?vue&type=template&id=8c968f88"
import script from "./CauseMultiples.vue?vue&type=script&lang=js"
export * from "./CauseMultiples.vue?vue&type=script&lang=js"

import "./CauseMultiples.vue?vue&type=style&index=0&id=8c968f88&lang=css"
script.render = render

export default script